import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SharedService } from '../shared.service';

@Component({
  selector: 'app-popup-box',
  templateUrl: './popup-box.component.html',
  styleUrls: ['./popup-box.component.scss'],
})

export class PopupBoxComponent {
  appTrackingUrl: string = environment.ADJUST_TRACKER_URL + "/" + environment.ADJUST_WEBSITE_TRACKER;
  isVisible: boolean = false;
  // @Output() onClose: EventEmitter<void> = new EventEmitter<void>();
  constructor(
    private sharedService: SharedService
  ) { }

  ngOnInit() {
    this.sharedService.appTrackingUrl.subscribe(value => {
      this.appTrackingUrl = value;
    });

    // Subscribe to popup state changes
    this.sharedService.popupState.subscribe((state: boolean) => {
      this.isVisible = state;
    });
  }



  closePopup(): void {
    console.log(`called`);

    this.isVisible = false;
    this.sharedService.togglePopup(false);
  }
}
